module.exports = __webpack_public_path__ + "img/image15.1d411f7c.png";